module.exports = __webpack_public_path__ + "img/53ne.1609aa51.svg";